import config from '../config.json';

export const CANADA_PHONE_REGEX =
  /^(\(\+[0-9]{2}\))?([0-9]{3}-?)?([0-9]{3})-?([0-9]{4})(\/[0-9]{4})?$/;
export const UK_PHONE_REGEX = /^(07[1-9]\d{7,11}|447[1-9]\d{6,10}|\+447[1-9]\d{6,11})$/;

export type SortDirection = 'asc' | 'desc';
export const SORT_DIRECTIONS: Record<string, SortDirection> = {
  ASC: 'asc',
  DESC: 'desc',
};

export const SEARCH_QUERY = 'search';
export const ACTIVE_QUERY = 'active';
export const ORDER_BY_QUERY = 'orderBy';
export const ORDER_DIRECTION_QUERY = 'order';
export const PAGE_QUERY = 'page';
export const ROWS_PER_PAGE_QUERY = 'rowsPerPage';
export const MIN_NAME_SEARCH_LENGTH = 3;
export const DEFAULT_PAGE = 1;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_ORDER_BY = 'createdAt';
export const DEFAULT_ORDER_DIRECTION = SORT_DIRECTIONS.DESC;

export const ONE_MINUTE_IN_MS = 60 * 1000;

export const DEPLOYMENT_REGIONS = {
  UK: 'uk',
  CA: 'canada',
} as const;

export type DeploymentRegion = (typeof DEPLOYMENT_REGIONS)[keyof typeof DEPLOYMENT_REGIONS];

export const { defaultTimezone, deploymentRegion, timeLocale } = config;

export default {};
